import React, { useState } from 'react';
import { SaveData } from '@/actions';
import { HeaderIcons } from '@/assets';
import Notification from '@/components/Notification';
import {
  Button,
  CircularProgress,
  IconButton,
  Toolbar,
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import { usePermissions } from 'react-admin';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import useMediaQuery from 'use-mediaquery';
import LogOutButton from '../LogOutButton';
import UserMenu from '../UserMenu';
import styles from './styles';
import { Timer } from './components/Timer';

export default () => {
  const { permissions } = usePermissions();
  const cls = styles();
  const openUserMenu = useSelector(
    (state) => state.reducer.openUserMenu || null
  );
  const history = useHistory();

  const isMobileDevice = useMediaQuery('(max-width: 763px)');
  const [loginLoading, setLoginLoading] = useState(false);

  const handleToggleMenu = () => {
    SaveData({ openUserMenu: !openUserMenu });
  };

  const handleRedirectToAdmin = () => {
    setLoginLoading(true);
    let adminToken = localStorage.getItem('token_admin');
    localStorage.setItem('token', adminToken);
    localStorage.setItem('permissions', 'admin');
    history.push('/dashboard');
    window.location.reload();
  };

  const handleToggleMenuBar = () => {
    document.getElementById('menuBar').style.display = 'flex';
    document.getElementById('menuOpenIcon').style.display = 'none';
    document.getElementById('layoutMain').style.marginLeft = '100px';
    document.getElementById('app_modal').style.left = '90px';

    if (typeof window.updateWidth === 'function') {
      window.updateWidth();
    } else {
      console.warn('window.updateWidth is not defined in this page!');
    }

    if (typeof window.updateHeadWidth === 'function') {
      window.updateHeadWidth();
    } else {
      console.warn('window.updateHeadWidth is not defined in this page!');
    }

    if (typeof window.syncScroll === 'function') {
      window.syncScroll('amirbios');
    } else {
      console.warn('window.syncScroll is not defined in this page!');
    }
  };

  return (
    <>
      <AppBar className={cls.header} position="fixed" elevation={0}>
        <Toolbar className={cls.toolbar}>
          <span className={cls.menuTuggleMobile}>
            <IconButton
              edge="start"
              color="inherit"
              sx={{ mr: 2 }}
              className={cls.menuIcon}
              onClick={() => handleToggleMenu()}>
              <MenuIcon />
              {/* <ReactSVG src={HeaderIcons.menuHandlerOpen} />{' '} */}
            </IconButton>
          </span>

          <span id="menuOpenIcon" className={cls.menuTuggle}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={() => handleToggleMenuBar()}>
              <ReactSVG src={HeaderIcons.menuHandlerOpen} />
            </IconButton>
          </span>

          <Link to="/">
            <img
              src={HeaderIcons.logosmartyellowdots}
              alt="Logo"
              className={cls.logo}
            />
          </Link>
          {/* {isSmallDevice ? (
            <MobileMenu />
          ) : (
            <div className={cls.linkCont}>
              <Link to="/" className={cls.link}>
                HOME
              </Link>
              <Link to="/how-it-works" className={cls.link}>
                HOW IT WORKS
              </Link>
              <Link to="/about" className={cls.link}>
                ABOUT
              </Link>
            </div>
          )} */}
          <span className={cls.spacer} />
          {/* <InputBase
            id="searchBar"
            placeholder="Search Offer or ..."
            variant="outlined"
            margin="dense"
            className={cls.search}
            endAdornment={
              <InputAdornment position="end">
                <SearchRounded className={cls.searchIcon} />
              </InputAdornment>
            }
          /> */}
          {/* {permissions !== 'admin' && <ChatBar />} */}
          <span className={cls.adminBtnContainer}>
            {permissions === 'user' &&
              localStorage.getItem('token_admin') &&
              !isMobileDevice && (
                <Button
                  className={cls.adminBtn}
                  onClick={() => handleRedirectToAdmin()}>
                  {loginLoading ? (
                    <CircularProgress className={cls.loginLoader} />
                  ) : (
                    'Redirect to Admin'
                  )}
                </Button>
              )}

            <Timer />

            <Notification autoClose={true} />
            <UserMenu>
              <LogOutButton />
            </UserMenu>
          </span>
        </Toolbar>
      </AppBar>
    </>
  );
};
